import React from 'react'

import { AccountActivitySortValue } from 'modules/accountActivity/domain'

export interface SortContextType {
  accountsSort: AccountActivitySortValue
  setAccountsSort: React.Dispatch<React.SetStateAction<AccountActivitySortValue>>
  accountsDescending: boolean
  setAccountsDescending: React.Dispatch<React.SetStateAction<boolean>>
  activitiesSort: AccountActivitySortValue
  setActivitiesSort: React.Dispatch<React.SetStateAction<AccountActivitySortValue>>
  activitiesDescending: boolean
  setActivitiesDescending: React.Dispatch<React.SetStateAction<boolean>>
  contactsSort: AccountActivitySortValue
  setContactsSort: React.Dispatch<React.SetStateAction<AccountActivitySortValue>>
  contactsDescending: boolean
  setContactsDescending: React.Dispatch<React.SetStateAction<boolean>>
  accountActivitySort: AccountActivitySortValue
  setAccountActivitySort: React.Dispatch<React.SetStateAction<AccountActivitySortValue>>
  accountActivityDescending: boolean
  setAccountActivityDescending: React.Dispatch<React.SetStateAction<boolean>>
  dealsSort: AccountActivitySortValue
  setDealsSort: React.Dispatch<React.SetStateAction<AccountActivitySortValue>>
  dealsDescending: boolean
  setDealsDescending: React.Dispatch<React.SetStateAction<boolean>>
}

export const SortContext = React.createContext<SortContextType>({
  accountsSort: AccountActivitySortValue.TRENDING,
  setAccountsSort: () => {},
  accountsDescending: true,
  setAccountsDescending: () => {},
  activitiesSort: AccountActivitySortValue.MOST_RECENT,
  setActivitiesSort: () => {},
  activitiesDescending: true,
  setActivitiesDescending: () => {},
  contactsSort: AccountActivitySortValue.MOST_RECENT,
  setContactsSort: () => {},
  contactsDescending: true,
  setContactsDescending: () => {},
  accountActivitySort: AccountActivitySortValue.MOST_RECENT,
  setAccountActivitySort: () => {},
  accountActivityDescending: true,
  setAccountActivityDescending: () => {},
  dealsSort: AccountActivitySortValue.MOST_RECENT,
  setDealsSort: () => {},
  dealsDescending: true,
  setDealsDescending: () => {}
})
